import { useState, useEffect } from 'react';
import { fetchWorkspaces } from '../services/API';

const useWorkspaces = communityId => {
  const [workspaces, setWorkspaces] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!communityId) {
      setWorkspaces([]);
      setIsLoading(false);
      return;
    }

    let cancelled = false;
    setIsLoading(true);

    fetchWorkspaces({ communityId })
      .then(data => {
        if (!cancelled) {
          setWorkspaces(data);
          setIsLoading(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setWorkspaces([]);
          setIsLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [communityId]);

  return { workspaces, isLoading };
};

export default useWorkspaces;
